import Image from 'app/Components/Shared/Image/image';
import React, {useState, useLayoutEffect, useEffect, useRef} from 'react';
import SwiperCore from 'swiper';
import {Navigation, Pagination} from 'swiper';
import {Swiper, SwiperSlide} from 'swiper/react';
import {prepareSameWindowUrl, prepareUrl} from 'app/utilities/StringHelpers/StringHelpers';
import {initial} from 'lodash';
import Config from 'app/Config';
import {TAB_ENUM} from '../../Constant';
import {connect} from 'react-redux';
import {setShowSelfCareMenu, setShowMenu} from '../../../../Block/HeaderMainBlock/HeaderBlockSlice';
import { getMarketCode } from 'app/utilities/domain/domainConstants';

SwiperCore.use([Navigation, Pagination]);

const CircularSwiperMobile = (props) => {
  const [swiper, setSwiper] = useState(null);
  const [initialSlideIndex, setInitialSlideIndex] = useState(0);
  const [isSwiperLoadedAfterFirstAnimation, setIsSwiperLoadedAfterFirstAnimation] = useState(false);

  const marketCode = getMarketCode().toLowerCase();
  function getBalanacedIconsInSwiper(index, total, maxY = 24) {
    if (total <= 1) return 0;
    const center = (total - 1) / 2;
    const distance = Math.abs(index - center);
    return Math.round((distance / center) * maxY);
  }

  function handleSlideChange(swiper) {
    props.setActiveIndex(swiper.activeIndex);
    let slidesInView = [];
    let slidesNotInView = [];

    let firstSlideIndex = swiper.isEnd ? swiper.activeIndex - 1 : swiper.activeIndex;
    let lastSlideIndex = Math.min(swiper.activeIndex + swiper.params.slidesPerView - 0.5, swiper.slides.length - 1);

    let lastActiveIndexAllowed = swiper.slides.length - 1 - 4;
    for (let i = firstSlideIndex; i <= lastSlideIndex; i++) {
      slidesInView.push(swiper.slides[i]);
    }
    for (let i = 0; i < swiper.slides.length; i++) {
      if (i < firstSlideIndex || (i > lastSlideIndex && i != lastActiveIndexAllowed)) {
        slidesNotInView.push(swiper.slides[i]);
      }
    }

    const visibleSlides = slidesInView.filter(Boolean);
    const count = visibleSlides.length;

    if (swiper.isEnd) {
      visibleSlides.forEach((slide, i) => {
        slide.style.transform = `translateY(${getBalanacedIconsInSwiper(count - 1 - i, count)}px)`;
      });
    } else {
      visibleSlides.forEach((slide, i) => {
        slide.style.transform = `translateY(${getBalanacedIconsInSwiper(i, count)}px)`;
      });
    }

    slidesNotInView.forEach((slide) => {
      if (slide) {
        slide.style.transform = 'translateY(24px)';
        slide.style.visibility = 'hidden';
        slide.id = slide.id;
      }
    });
    slidesInView.forEach((slide) => {
      if (slide) {
        slide.style.visibility = 'visible';
        slide.id = slide.id;
      }

    });
    if (!isSwiperLoadedAfterFirstAnimation) {
      setIsSwiperLoadedAfterFirstAnimation(true);
    }
  }

  useEffect(() => {
    if (swiper != null && swiper.slides) {
      setTimeout(() => {
        swiper.slides.forEach((slide) => {
          slide.style.transitionDuration = '0.4s';
        });
      }, 2000);
    }
  }, [isSwiperLoadedAfterFirstAnimation]);

  useEffect(() => {
    if (swiper != null && swiper.slides && props.arr[swiper.clickedIndex]?.id !== props.currentPage.toLowerCase())
      props.handleSelectedIndex(swiper, props.arr);
  }, [props.currentPage]);

  function handleOnInit(swiper) {
    props.handleSelectedIndex(swiper, props.arr);
  }

  useEffect(() => {
    if (swiper && swiper.slides && props.isFetchLoginData) {
      handleSlideChange(swiper);
      props.handleSelectedIndex(swiper, props.arr);
    }
  }, [swiper, props.isFetchLoginData]);

  const setSwiperInstance = (swiperInstance) => {
    setSwiper(swiperInstance);
  };
  async function getLink(itemId) {
    return await prepareSameWindowUrl(Config.lobbyUrl.split('/').slice(1, -2).join('/') + '/' + itemId);
  }


  const getImageUrl =( itemId, extension,isGrayImg )=>{
      
    const folder =`./images/icons/${itemId.toLowerCase()}/${itemId.toLowerCase()}`;
    if(itemId !=null){
        if (extension === 'gif' || itemId === 'main') {
          return require(`${folder}-${marketCode}.${extension}`);
        }
        return require(`${folder}${isGrayImg ? "-gray" : ""}.${extension}`);
      }
      return null;
  }


  return (
    <div className={`main-container ${props.selectedIndex == 0 && props.activeIndex == 0 ? 'first-slide' : ''} ${props.arr && props.arr.length < 5 ? 'few-items' : ''}`}>
      {props.isFetchLoginData && props.arr != null && (
        <>
          <Swiper
            id='circular-swiper-mobile'
            onSwiper={(swiperInstance) => {
              setSwiperInstance(swiperInstance);
            }}
            onClick={(swiper) => {
              swiper.slideTo(swiper.clickedIndex != 0 ? swiper.clickedIndex - 1 : swiper.clickedIndex);
              if (swiper.clickedSlide) {
                props.setSelectedIndex(swiper.clickedIndex);
              }
              props.setShowSelfCareMenu(false);
              props.setShowMenu(false);
              // event.preventDefault()
              prepareUrl(props.arr[swiper.clickedIndex].worldLink, props.context);
            }}
            initialSlide={props.activeIndex}
            onInit={(swiper) => handleOnInit(swiper)}
            slidesPerView={4.5}
            slidesPerGroup={1}
            navigation={false}
            pagination={false}
            onSlideChange={(swiper) => handleSlideChange(swiper)}
            speed={500}
            followFinger={false}
            style={{overflow: 'hidden'}}
            loop={false}
            spaceBetween={0}
            slidesOffsetBefore={0}
            slidesOffsetAfter={0}
            touchAngle={45}
            resistance={false}
            roundLengths={false}
            touchRatio={1}>
            {props.arr &&
              props.arr.map((item, i) => (
                <SwiperSlide
                  key={i}
                  id='circular-swiper-mobile-slide'
                  className={'circular-swiper-mobile-slide' + ' ' + props.selectedIndex == i ? 'selected' : ''}>
                  <a
                    href={item.worldLink || '#'}
                    onClick={(event) => {
                      event.preventDefault();
                      event.stopPropagation();
                      // Let Swiper handle the navigation
                    }}
                    className={`circle ${props.selectedIndex == i ? 'selected' : ''} ${!item.tabData && i != 0 ? 'grey' : ''}`}>
                    {(i === 0 || item.tabData) ? (
                      props.selectedIndex === i
                        ? <Image src={getImageUrl(item.id, 'gif', false)} />
                        : <Image width={40} height={40} src={getImageUrl(item.id, 'svg', false)} />
                    ) : (
                      <Image src={getImageUrl(item.id, 'png', true)} />
                    )}

                    {item.isShowBadge && item.tabData && (
                      <div className='circle-badge'>
                        <Image src={props.epiBaseUrl + item.badgeImg} />
                      </div>
                    )}
                    {!item.tabData && i != 0 && (
                      <div className='circle-badge'>
                        <span>
                          <svg width='28' height='28' viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg'>
                            <circle cx='14' cy='14' r='12' fill='#FFDE31' />
                            <circle cx='14' cy='14' r='12.5714' stroke='#BAB68B' strokeOpacity='0.2' strokeWidth='1.14286' />
                            <path
                              fillRule='evenodd'
                              clipRule='evenodd'
                              d='M13.9939 19.8202C14.3545 19.8202 14.6457 19.5289 14.6457 19.1683L14.6503 14.6518L19.1715 14.6518C19.5321 14.6518 19.8233 14.3606 19.8233 14C19.8233 13.6394 19.5321 13.3482 19.1715 13.3482L14.6503 13.3482L14.6503 8.82703C14.6503 8.46645 14.3591 8.17521 13.9985 8.17521C13.6379 8.17521 13.3467 8.46645 13.3467 8.82703L13.3467 13.3482H8.82556C8.46497 13.3482 8.17373 13.6394 8.17374 14C8.17373 14.3606 8.46497 14.6518 8.82556 14.6518H13.3467L13.3467 19.173C13.3467 19.5243 13.6426 19.8202 13.9939 19.8202Z'
                              fill='black'
                            />
                          </svg>
                        </span>
                      </div>
                    )}
                  </a>
                  <div className='circle-text-container'>
                    <div className='circle-text title'>{i == 0 ? 'ראשי' : item.tabTitle}</div>
                    <div className='circle-text sub-title'>{i == 0 ? 'ראשי' : item.tabSubTitle}</div>
                  </div>
                </SwiperSlide>
              ))}
          </Swiper>
        </>
      )}
    </div>
  );
};
const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = {
  setShowSelfCareMenu,
  setShowMenu,
};

export default connect(mapStateToProps, mapDispatchToProps)(CircularSwiperMobile);
